export const PEDIDO_VOO_FIND_ONE = 'PEDIDO_VOO_FIND_ONE';
export const PEDIDO_VOO_FIND_ONE_SUCCESS = 'PEDIDO_VOO_FIND_ONE_SUCCESS';

export const PEDIDO_VOO_SAVE = 'PEDIDO_VOO_SAVE';
export const PEDIDO_VOO_SAVE_SUCCESS = 'PEDIDO_VOO_SAVE_SUCCESS';

export const PEDIDO_VOO_UPDATE = 'PEDIDO_VOO_UPDATE';
export const PEDIDO_VOO_UPDATE_SUCCESS = 'PEDIDO_VOO_UPDATE_SUCCESS';

export const PEDIDO_VOO_VALIDATE = 'PEDIDO_VOO_VALIDATE';
export const PEDIDO_VOO_VALIDATE_SUCCESS = 'PEDIDO_VOO_VALIDATE_SUCCESS';

export const PEDIDO_VOO_DELETE = 'PEDIDO_VOO_DELETE';
export const PEDIDO_VOO_DELETE_SUCCESS = 'PEDIDO_VOO_DELETE_SUCCESS';

export const PEDIDO_VOO_CLEAR_SELECTED = 'PEDIDO_VOO_CLEAR_SELECTED';
export const PEDIDO_VOO_CLEAN = 'PEDIDO_VOO_CLEAN';

export const PEDIDO_VOO_FIND_ARQUIVOS = 'PEDIDO_VOO_FIND_ARQUIVOS';
